module.exports = __webpack_public_path__ + "img/header-logo.a2e7198f.png";